import type { StoreApi } from '../../types';

export const setDialogOpen =
	(isOpen: boolean) =>
	({ getState, setState }: StoreApi) => {
		const { meta: currentMeta } = getState();

		setState({
			meta: {
				...currentMeta,
				isDeleteAllDialogOpen: isOpen,
			},
		});
	};
